"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PY_TYPE_POTENTIALCUST = exports.PY_TYPE_CUST = exports.PT_STATUS_TASK = exports.PT_STATUS_PLAN = void 0;
/**
 * 类型 ，计划、任务，由前端自行维护
 */
var PT_STATUS_PLAN = exports.PT_STATUS_PLAN = 'N'; // 计划
var PT_STATUS_TASK = exports.PT_STATUS_TASK = 'Y'; // 任务

var PY_TYPE_CUST = exports.PY_TYPE_CUST = 'A01'; // 类型 门店拜访
var PY_TYPE_POTENTIALCUST = exports.PY_TYPE_POTENTIALCUST = 'A10'; // 类型 潜客门店拜访